import React, { useEffect } from 'react';
import { fetchChatMessages } from '../../data/fetch';
import { useStoredDataChanged } from './useStoredDataChanged';
import Loader from './Loader';
import { usePushNotifications } from '../../data/hooks/pushNotifications';

const LoadChatMessages = ({ sessionId, children }) => {
    useStoredDataChanged();

    return (
        <Loader id={'load-chat-messages'} skipSpinner promises={[fetchChatMessages(sessionId)]}>
            {children}
        </Loader>
    );
};

export default LoadChatMessages;
